"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addGroupBottomY = void 0;
var getFromMap_1 = require("./getFromMap");
var getNodeBottomY_1 = require("./getNodeBottomY");
function addGroupBottomY(subtree, settings, map) {
    subtree.groupBottomY = getNodeBottomY_1.getNodeBottomY(subtree);
    var siblings = getFromMap_1.getFromMap(subtree[settings.nextBeforeAccessor], map);
    siblings === null || siblings === void 0 ? void 0 : siblings.forEach(function (sibling) {
        subtree.groupBottomY = Math.max(subtree.groupBottomY, getNodeBottomY_1.getNodeBottomY(sibling));
    });
    var partners = getFromMap_1.getFromMap(subtree[settings.nextAfterAccessor], map);
    partners === null || partners === void 0 ? void 0 : partners.forEach(function (partner) {
        subtree.groupBottomY = Math.max(subtree.groupBottomY, getNodeBottomY_1.getNodeBottomY(partner));
    });
}
exports.addGroupBottomY = addGroupBottomY;
//# sourceMappingURL=addGroupBottomY.js.map